(function () {
  function initPairSelector(container) {
    const unitInput = container.querySelector('[data-pair-type="unit"]');
    const pairInput = container.querySelector('[data-pair-type="pair"]');
    const selectedValueEl = container.querySelector('[data-pair-selected-value]');

    if (!unitInput || !pairInput) return;

    let currentType = 'unit';

    function getUnitPriceCents() {
      const variantData = document.querySelector('[data-selected-variant]');
      if (variantData) {
        try {
          return JSON.parse(variantData.textContent).price;
        } catch (e) {}
      }
      return null;
    }

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + '\u00a0€';
    }

    function updatePrice() {
      const unitPrice = getUnitPriceCents();
      if (!unitPrice) return;
      const multiplier = currentType === 'pair' ? 2 : 1;
      const priceEl = document.querySelector('.price__regular .price-item--regular');
      if (priceEl) {
        priceEl.textContent = formatPrice(unitPrice * multiplier);
      }
    }

    function updateLabel() {
      if (selectedValueEl) {
        selectedValueEl.textContent = currentType === 'pair' ? 'Paire' : 'Unité';
      }
    }

    function updateQuantityInput() {
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = currentType === 'pair' ? 2 : 1;
      }
    }

    unitInput.closest('label').addEventListener('click', () => {
      currentType = 'unit';
      updateLabel();
      updatePrice();
      updateQuantityInput();
    });

    pairInput.closest('label').addEventListener('click', () => {
      currentType = 'pair';
      updateLabel();
      updatePrice();
      updateQuantityInput();
    });

    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' && e.target.classList.contains('product-variant-id')) {
        if (currentType === 'pair') {
          const priceEl = document.querySelector('.price__regular .price-item--regular');
          if (priceEl) priceEl.style.opacity = '0';
          setTimeout(() => {
            updatePrice();
            const priceElAfter = document.querySelector('.price__regular .price-item--regular');
            if (priceElAfter) priceElAfter.style.opacity = '1';
          }, 400);
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-pair-selector]').forEach(initPairSelector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();